/* nm-hscroll: prev/next arrows for horizontal scroll lists (home "Meilleures ventes" + "Le blog").
   Markup: [data-nm-hscroll] > [data-nm-hscroll-list] > [data-nm-hscroll-item]; buttons [data-nm-hscroll-prev|next]. */
(function () {
  if (window.__nmHscroll) return;
  window.__nmHscroll = true;
  function init(root) {
    if (root.__nmHs) return;
    root.__nmHs = true;
    var list = root.querySelector('[data-nm-hscroll-list]');
    var prev = root.querySelector('[data-nm-hscroll-prev]');
    var next = root.querySelector('[data-nm-hscroll-next]');
    if (!list || !prev || !next) return;
    function step() {
      var item = list.querySelector('[data-nm-hscroll-item]');
      if (!item) return list.clientWidth;
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = list.scrollWidth - list.clientWidth - 2;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function all() { document.querySelectorAll('[data-nm-hscroll]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
